import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="inline-edit"
export default class extends Controller {
  static targets = ["display", "form", "input"]
  static values = { url: String }

  connect() {
    this.originalValue = this.inputTarget.value
  }

  edit() {
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel() {
    this.inputTarget.value = this.originalValue
    this.displayTarget.classList.remove("hidden")
    this.formTarget.classList.add("hidden")
  }

  async save(event) {
    event.preventDefault()
    
    const newValue = this.inputTarget.value.trim()
    
    // If empty or unchanged, just cancel
    if (!newValue || newValue === this.originalValue) {
      this.cancel()
      return
    }

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({ portrait: { title: newValue } })
      })

      if (response.ok) {
        // Update the display text
        this.displayTarget.querySelector("h1").textContent = newValue
        this.originalValue = newValue
        this.cancel()
      } else {
        alert("Failed to update title. Please try again.")
      }
    } catch (error) {
      console.error("Error updating title:", error)
      alert("An error occurred. Please try again.")
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.cancel()
    } else if (event.key === "Enter") {
      event.preventDefault()
      this.save(event)
    }
  }
}
